"use server";

import { changePassword } from "@/src/actions/auth-session";
import { apiFetchCustomerServer } from "@/src/lib/api/fetch.server";
import { requireActor } from "@/src/lib/api/require-actor";

export interface SettingsData {
  email: string;
  firstName: string;
  lastName: string;
  phone: string;
  companyName: string;
  location: string;
}

type MeResponse = {
  email: string;
  name: string | null;
  phone: string | null;
  companyName: string | null;
  location: string | null;
};

export async function getSettingsData(): Promise<SettingsData> {
  await requireActor();
  const me = await apiFetchCustomerServer<MeResponse>("/users/me");
  const fullName = me.name ?? "";
  const [firstName = "", ...rest] = fullName.trim().split(" ");
  const lastName = rest.join(" ");

  return {
    email: me.email,
    firstName,
    lastName,
    phone: me.phone ?? "",
    companyName: me.companyName ?? "",
    location: me.location ?? "",
  };
}

export async function updateProfileAction(data: {
  firstName: string;
  lastName: string;
  phone: string;
}): Promise<{ success: boolean; error?: string }> {
  try {
    await requireActor();
    const name =
      [data.firstName, data.lastName].filter(Boolean).join(" ") || null;
    await apiFetchCustomerServer("/users/me", {
      method: "PATCH",
      body: JSON.stringify({ name, phone: data.phone || null }),
    });
    return { success: true };
  } catch {
    return { success: false, error: "Failed to update profile" };
  }
}

export async function updateCompanyAction(data: {
  companyName: string;
  location: string;
}): Promise<{ success: boolean; error?: string }> {
  try {
    await requireActor();
    await apiFetchCustomerServer("/users/me", {
      method: "PATCH",
      body: JSON.stringify({
        companyName: data.companyName || null,
        location: data.location || null,
      }),
    });
    return { success: true };
  } catch {
    return { success: false, error: "Failed to update company" };
  }
}

export async function changePasswordAction(data: {
  currentPassword: string;
  newPassword: string;
}): Promise<{ success: boolean; error?: string }> {
  const result = await changePassword(data);
  if (!result.success) {
    return {
      success: false,
      error: result.error ?? "Current password is incorrect",
    };
  }
  return { success: true };
}
